<mat-icon [style.color]="color()">
  {{ icon() }}
</mat-icon>
